export default __webpack_public_path__ + "static/media/April2019.07e35eb8.png";